import { useTranslation } from "react-i18next";

import { AuthConfig } from "../../../../setup/context/config/authConfig";
import { IContractProps } from "../../models";
import styles from "./styles.module.scss";
import { UserInfo } from "./userInfo";

export interface Props extends IContractProps {
  toggleModal?: () => void;
}

export const ReceiverInfo = ({ contract }: Props) => {
  const userId = AuthConfig.getUserInfo()?.id;
  const { t } = useTranslation();
  const returnTitle = () => {
    return contract.senderId == userId
      ? t("lbl_receiver_info")
      : t("lbl_sender_info");
  };

  return (
    <div>
      <h4>{returnTitle()}</h4>
      <div className={styles["user_container"]}>
        <div>
          <UserInfo contract={contract} />
        </div>
      </div>
    </div>
  );
};
